import { render, staticRenderFns } from "./SaldosPorLocal.vue?vue&type=template&id=d0c45ed6&"
import script from "./SaldosPorLocal.vue?vue&type=script&lang=js&"
export * from "./SaldosPorLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports